var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransition({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "19px",
    viewBox: "0 0 24 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0746CE8A-9EBD-4734-894C-9572E4BD7913") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Sidebar-/-Inicio",
    transform: "translate(-22.000000, -156.000000)",
    fill: "#B4B4B4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transition",
    transform: "translate(22.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.15822755,9.56399714 C4.43613852,9.85552899 4.88673573,9.85542943 5.16455182,9.56399714 C5.44255768,9.27226616 5.44255768,8.79952256 5.16445694,8.50779158 L2.42994199,5.63837339 L23.2884758,5.63825515 C23.6814793,5.63815559 24,5.30390954 24,4.89130435 C23.9999051,4.47889829 23.6813844,4.14475181 23.2883809,4.14475181 L2.42956246,4.14487004 L5.16474159,1.27485445 C5.44265256,0.983223034 5.44265256,0.510280309 5.16474159,0.218748456 C5.02573866,0.07298253 4.84365906,0 4.66148457,0 C4.47940496,0 4.29732536,0.07298253 4.15832243,0.218648889 L0.208456952,4.36341937 C0.0749572108,4.50341041 0,4.69328447 0,4.89142258 C9.48825453e-05,5.08956069 0.0750520933,5.27933518 0.208551835,5.41962493 L4.15822755,9.56399714 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15822755,18.5313884 C4.43613852,18.8229203 4.88673573,18.8228207 5.16455182,18.5313884 C5.44255768,18.2396575 5.44255768,17.7669139 5.16445694,17.4751829 L2.42994199,14.6057647 L23.2884758,14.6056465 C23.6814793,14.6055469 24,14.2713008 24,13.8586957 C23.9999051,13.4462896 23.6813844,13.1121431 23.2883809,13.1121431 L2.42956246,13.1122613 L5.16474159,10.2422458 C5.44265256,9.95061434 5.44265256,9.47767161 5.16474159,9.18613976 C5.02573866,9.04037383 4.84365906,8.9673913 4.66148457,8.9673913 C4.47940496,8.9673913 4.29732536,9.04037383 4.15832243,9.18604019 L0.208456952,13.3308107 C0.0749572108,13.4708017 0,13.6606758 0,13.8588139 C9.48825453e-05,14.056952 0.0750520933,14.2467265 0.208551835,14.3870162 L4.15822755,18.5313884 Z",
    id: "Path",
    transform: "translate(12.000000, 13.858696) scale(-1, 1) translate(-12.000000, -13.858696) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransition);
export default __webpack_public_path__ + "static/media/transition.36a2691a73796b59ab5a092c956262c8.svg";
export { ForwardRef as ReactComponent };